import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';

const SimpleTableSkeleton = ({ columns = [], rowCount = 10, height = 20 }) => {
  return (
    <div className={`table-container`}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            {columns.map((col, index) => (
              <th key={index}  className={styles.theadD}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((_, colIndex) => (
                <td key={colIndex}  className={styles.tableCell}>
                  <Skeleton height={height} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimpleTableSkeleton;